<template>
  <div>
    <div class="d-flex mb-3">
      <h3
        style="font-weight: 500"
        class="mr-3"
      >
        Gestion des groupes
      </h3>
      <span class="smaller-text d-flex align-center pr-3">
        {{ numInfos }}
      </span>
      <ClosableDialog
        v-if="maxGroups === undefined || numGroups < maxGroups"
        icon="group_add"
        ref="newGroupDialog"
      >
        <GroupForm
          :organization="organization"
          @saved="saved"
        />
      </ClosableDialog>
    </div>
    <div class="d-flex justify-center pa-3" v-if="loading">
      <v-progress-circular
        indeterminate
        :size="30"
        :width="4"
      />
    </div>
    <div
      v-else
      v-for="group in organization.groups"
      :key="group.id"
    >
      <v-card
        outlined
        elevation="1"
        class="pa-2 d-flex align-center justify-space-between"
      >
        <div>
          <span
            class="ml-1"
          >
            {{ group.name }}
          </span>
          <span
            class="ml-2 smaller-text"
          >
            {{ group.id }}
          </span>
        </div>
        <div class="d-flex justify-end">
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-if="group.isPrivate"
              >
                lock
              </v-icon>
            </template>
            <span>Groupe privé</span>
          </v-tooltip>
          -->
          <ClosableDialog icon="settings" ref="updateGroupDialog">
            <GroupForm
              :organization="organization"
              :group="group"
              @saved="saved"
            />
          </ClosableDialog>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import ClosableDialog from '@/shared/components/dialog/ClosableDialog';
import GroupForm from './GroupForm';

export default {
  name: 'GroupManagement',
  components: { ClosableDialog, GroupForm },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.update();
  },
  watch: {
    organization() {
      this.update();
    },
  },
  data() {
    return {
      maxGroups: undefined,
      numGroups: undefined,
      numInfos: '',
    };
  },
  methods: {
    update() {
      if (!this.organization.groups) return;

      this.numGroups = this.organization.groups.length;
      this.maxGroups = this.organization.maxGroups;

      if (this.maxGroups) {
        this.numInfos = `${this.numGroups}/${this.maxGroups}`;
      } else {
        this.numInfos = `${this.numGroups}`;
      }
    },
    saved() {
      if (this.$refs.newGroupDialog) {
        this.$refs.newGroupDialog.close();
      }
      this.closeUpdateGroupDialogs();
      this.$emit('saved');
    },
    closeUpdateGroupDialogs() {
      try {
        this.$refs.updateGroupDialog.forEach(dialog => {
          try {
            dialog.close();
          } catch {
            // ignore, we need to try to call close on all dialog
          }
        });
      } catch {
        // ignore, easier the check if it exists, if it's a list, etc.
      }
    },
  },
};
</script>
<style>
.smaller-text {
  font-size: 12px;
  font-weight: 300;
}
</style>
